module.exports = __webpack_public_path__ + "fonts/AvenirNextCyr-BoldItalic.5d4fb98b.ttf";